export default "__VITE_ASSET__pHS1QPXH__"